{
  "title": "Oyun lobbisi",
  "subtitle": "Aggregator kataloqundakı bütün oyunlar burada əlçatandır.",
  "searchPlaceholder": "Oyun axtar",
  "history": "Oyun tarixçəsi",
  "searchResults": "Axtarış",
  "bonusContinueTitle": "Bonus ilə davam?",
  "bonusContinueBody": "Əsas balans 0-dır. Bonus balansınız var — yalnız sizin seçiminizlə istifadə olunur.",
  "openExternal": "Oyunu aç",
  "openExternalHint": "Oyun daxili pəncərədə açılmırsa, aşağıdakı düymə ilə açın.",
  "backToCatalog": "Kataloqa qayıt",
  "notFound": "Oyun tapılmadı",
  "categories": "Kateqoriyalar",
  "all": "Hamısı",
  "slots": "Slotlar",
  "live": "Canlı kazino",
  "crash": "Crash",
  "instant": "Instant",
  "table": "Masa",
  "other": "Digər",
  "popular": "Populyar",
  "new": "Yeni",
  "jackpot": "Jackpot",
  "tags": "Filtrlər",
  "providers": "Provayderlər",
  "emptyTitle": "Oyunlar hələ əlçatan deyil",
  "emptyBody": "Provayder kataloqu sinxronlaşdırılmayıb. Real və ya demo oyunlar yalnız təsdiqlənmiş inteqrasiyadan sonra aktivləşəcək.",
  "errorTitle": "Kataloq yüklənmədi",
  "errorBody": "Oyun siyahısı alınarkən xəta baş verdi. Bir az sonra yenidən cəhd edin.",
  "notPlayable": "Hal-hazırda açıla bilməz",
  "demoUnavailable": "Demo hələ aktiv deyil",
  "realMoneyDisabled": "Real pullu oyunlar deaktivdir",
  "provider": "Provayder",
  "results": "{{count}} oyun",
  "featured": "Seçilmiş",
  "lobbySection": "Kataloq",
  "allProviders": "Bütün provayderlər",
  "sort": "Sıralama",
  "sortRecommended": "Tövsiyə olunan",
  "sortName": "Ad",
  "sortProvider": "Provayder",
  "favorite": "Sevimli",
  "selectWallet": "Oyun üçün balans seçin",
  "realBalance": "Əsas balans",
  "bonusBalance": "Bonus balans",
  "fundingLocked": "Seçilmiş balans bütün oyun sessiyası ərzində saxlanılır. Real və bonus birləşdirilmir.",
  "launchPlay": "Oyunu aç",
  "bonusNotSlot": "Bonus yalnız təsdiqlənmiş slotlarda istifadə olunur",
  "bonusPlayDisabled": "Bonus oyun hələ aktiv deyil",
  "sessionFundingUnsupported": "Provayder sessiyanı təhlükəsiz bağlaya bilmədi. Bu rejim açılmadı.",
  "loginToPlay": "Oynamaq üçün daxil olun",
  "sessionLaunched": "Oyun sessiyası yaradıldı",
  "loadMore": "Daha çox göstər",
  "loadingMore": "Yüklənir…",
  "showingOf": "{{shown}} / {{total}} oyun",
  "launchDemo": "DEMO OYNA",
  "launchReal": "REAL BALANSLA OYNA",
  "launchBonus": "BONUS BALANSI İLƏ OYNA",
  "demoLaunched": "Demo sessiyası yaradıldı",
  "recommended": "Tövsiyə olunanlar",
  "fastGames": "Sürətli oyunlar",
  "bonusWager": "Bonusla mərc"
}
